import { PalmTour, Hotel, TripMap } from '@lt/components/icons-react';

export const SEARCH_TYPE_NAMES = {
  PACKAGE: 'package',
  HOTEL: 'hotel',
  TRIP: 'trip',
} as const;

export const SEARCH_TYPES = [
  {
    name: SEARCH_TYPE_NAMES.PACKAGE,
    label: 'Туры',
    Icon: PalmTour,
  },
  {
    name: SEARCH_TYPE_NAMES.HOTEL,
    label: 'Отели',
    altLabel: 'Только проживание',
    Icon: Hotel,
  },
  {
    name: SEARCH_TYPE_NAMES.TRIP,
    label: 'Экскурсии',
    Icon: TripMap,
  },
];
